// extracted by mini-css-extract-plugin
export var footer = "rQmFG3Pw";
export var title = "FX1VNVjP";
export var spread = "_3YrxEuFD";
export var clicked = "_7HARRqXc";
export var items = "_1uaUbkoZ";
export var displayed = "ukwfjr9A";
export var socials = "yJXQELFO";
export var tooltipQR = "tGDlpdR9";
export var column = "gx2prTCQ";
export var annotations = "thpzA-4J";
export var copyright = "KNInhzvj";
export var logo = "qtY9OKaL";
export var logoAndCopyright = "_3CThE9sg";
export var socialMediaLinks = "IuVAOfIC";
export var socialMediaLink = "_9XCrh-+e";
export var socialMediaLinkAnchor = "+YpD8SlN";
export var infoAndLinks = "P9VijNrg";
export var linkRows = "qz7RQoKy";